import { animate, state, style, transition, trigger, } from '@angular/animations';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { TableauMessages } from '../../../models/component-messages/tableau-messages';
import { TableContent } from './model/table.content';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LogService } from '../../../services/log.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '../../../modals/information/information.component';
import { CanNavigateInStepperService } from '../../../services/can-navigate-in-stepper.service';
import { Constants } from '../../models/constants';
import { PreferenceMessages } from '../../../models/component-messages/preference-messages';
import { PresseSpecialiseComponent } from '../../../modals/presse-specialise/presse-specialise.component';
import { takeUntil } from 'rxjs/operators';
import { Diffuseur } from '../../../../../models/diffuseur';
import { ModalDiffuseurComponent } from '../../../../avisDePub/preferences-avis-de-pub/modals/modal-diffuseur/modal-diffuseur.component';
import { environment } from '../../../../../../environments/environment';
import { SelectionModel } from '@angular/cdk/collections';
import { Flux } from '../../../../../models/flux';


@Component({
  selector: 'app-tableau-diffuseur',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class TableauDiffuseurComponent implements OnInit, OnChanges, OnDestroy {

  /** Avis eForms pour lesquels le support BOAMP est imposé : case cochée et grisée. */
  private static readonly EFORMS_AUTO_CHECK_BOAMP = ['12', '16', '17', '19', '23', '24', '29', '30', '31', '32', '33', '34', '35', '36', '37'];

  constructor(public translate: TranslateService, private fb: FormBuilder, private cd: ChangeDetectorRef,
              private modalService: NgbModal, private canNavigateInStepperService: CanNavigateInStepperService
  ) {
    this.isPrefActivated = environment.pref === 'true';
    this.isShalEnabled = environment.shal_enabled === 'true';
  }

  private LOG: LogService = new LogService(TableauDiffuseurComponent);
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  @ViewChild('myTable') matTable: MatTable<any>;
  @Input() tableContent: TableContent;
  @Output() actionEvent: EventEmitter<any> = new EventEmitter();
  @Output() formOutput: EventEmitter<FormGroup> = new EventEmitter();
  @Input() form: FormGroup;
  @Input() mode: Number;
  @Output() presseOutput: EventEmitter<Diffuseur> = new EventEmitter();

  public preferenceMessages = new PreferenceMessages();
  public tableauMessage = new TableauMessages();
  public tableDataSrc: MatTableDataSource<any>;
  public expandedElement: Data[] = [];
  public expandedColumn: string[] = [];
  public usersData: any[] = [];
  public dataRows: FormGroup = new FormGroup({});
  public isForm = false;
  public myjson: any = JSON;
  public row: FormGroup;
  public rowChild: FormGroup;
  selection = new SelectionModel<any>(true, []);
  selectionChild = new SelectionModel<any>(true, []);
  selectionMap: Map<number, SelectionModel<any>> = new Map<number, SelectionModel<any>>();
  visibleMap: Map<number, SelectionModel<any>> = new Map<number, SelectionModel<any>>();
  diffuseurAvisReference: Flux[];
  diffIdAvisRef: any[] = [];
  subscriber: any = null;
  subbed: any;
  changing: any;
  subRef: Subscription = null;
  public avisNbPerPage: number = 0;

  isPrefActivated = false;
  isShalEnabled = false;

  /** Vrai lorsque le formulaire actuellement sélectionné impose le support BOAMP. */
  private isBoampAutoCheck = false;

  private unsubscribe$ = new Subject<void>();
  private subscription: Subscription;

  public ngOnInit() {
    this.isForm = this.form !== undefined && this.form !== null;
    if (!this.isForm) {
      this.form = new FormGroup({});
    }
    this.form.addControl(Constants.TABLE_DATA_CTRL_NAME, this.dataRows);
    this.canNavigateInStepperService.mockedCompatibilite(this.compatibilite.bind(this));
    this.subscribeRef();
    this.fillTableData();
    this.subscription = this.canNavigateInStepperService.element$.subscribe((element) => {
      this.autoCheckBoamp(element);
    });
  }

  autoCheckBoamp(element) {
    const extractedNumber = element?.match(/\d+/)?.[0];
    this.isBoampAutoCheck = !!extractedNumber && TableauDiffuseurComponent.EFORMS_AUTO_CHECK_BOAMP.includes(extractedNumber);
    this.forceBoampSiImpose();
  }

  /**
   * Réapplique le verrouillage de la case BOAMP (cochée + grisée) pour les avis qui l'imposent.
   * Appelé après chaque recalcul de compatibilité, qui réactive sinon la ligne BOAMP.
   */
  private forceBoampSiImpose() {
    if (!this.isBoampAutoCheck) {
      return;
    }
    const boampCtrl = this.getBoampFormGroup();
    if (!boampCtrl) {
      return;
    }
    boampCtrl.controls.checked.setValue(true);
    boampCtrl.controls.checked.disable();
    boampCtrl.controls.checkbox.disable();
  }

  /** Retrouve le FormGroup de la ligne correspondant au diffuseur BOAMP dans le tableau. */
  private getBoampFormGroup(): FormGroup | undefined {
    const diffFormGrp: any = this.form.get(Constants.TABLE_DATA_CTRL_NAME);
    return Object.values<FormGroup>(diffFormGrp?.controls ?? {})
      .find((ctrl: any) => ctrl.controls?.diffuseur?.value === 'BOAMP');
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private subscribeRef() {
    if (!this.subRef)
      this.subRef = this.canNavigateInStepperService.diffReference.subscribe(diffAviRef => {

        this.diffuseurAvisReference = diffAviRef;

        this.diffIdAvisRef = [];
        if (this.diffuseurAvisReference != undefined && this.diffuseurAvisReference != null) {
          this.diffuseurAvisReference.forEach(d =>
            this.diffIdAvisRef.push(d)
          );
        }
        this.compatibilite(true);
      });
  }



  public ngOnChanges(changes: SimpleChanges) {
    if (changes.tableContent) {

      // Vérifier si le contrôle existe
      const tableDataCtrl = this.form.get(Constants.TABLE_DATA_CTRL_NAME);
      this.tableDataSrc = new MatTableDataSource([]);
      this.usersData = [];
      this.selectionMap.clear();
      this.visibleMap.clear();

    }

    this.subscribeRef();
    this.fillTableData();
  }

  fillTableData() {

    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }



    this.subscriber = this.tableContent.tableData.subscribe((data) => {
      if (data) {
        this.dataRows = new FormGroup({});
        this.usersData = data;
        // expandable
        data.forEach((principalRowData) => {
          this.row = this.fb.group({
            develop: new FormControl(principalRowData.develop),
            checkbox: new FormControl(principalRowData.checkbox),
            zonediffusion: new FormControl(principalRowData.zonediffusion),
            diffuseur: new FormControl(principalRowData.support),
            format: new FormControl(principalRowData.format),
            children: new FormGroup({}),
            // checked du premier niveau
            checked: new FormControl(principalRowData.checked),
            visible: new FormControl(principalRowData.visible)
          });

          const zonediffusionctrl: any = this.row.controls.zonediffusion;
          zonediffusionctrl.disable();
          const diffuseurctrl: any = this.row.controls.diffuseur;
          diffuseurctrl.disable();
          const formatctrl: any = this.row.controls.format;
          formatctrl.disable();
          // ajout d'une ligne dans le tableau
          this.dataRows.addControl(principalRowData.id, this.row);
          this.dataRows.setControl(principalRowData.id, this.row);

          if (principalRowData && principalRowData.children && Array.isArray(principalRowData.children) && principalRowData.children.length) {
            principalRowData.children.forEach((element) => {
              if (this.tableContent.tableCols.find((value) => 'action' === value.columnDef)) {
                element.actions = [];
                this.tableContent.tableCols.find((value) => 'action' === value.columnDef).actions.forEach((item) => {
                  const action = {
                    description: item.description,
                    icon: item.icon,
                    matTooltip: item.matTooltip,
                    type: item.type,
                  };
                  element.actions.push(action);
                });
              }

              this.rowChild = this.fb.group({
                develop: new FormControl(element.develop),
                checkbox: new FormControl(principalRowData.checkbox),
                zonediffusion: new FormControl(element.zonediffusion),
                diffuseur: new FormControl(element.support),
                format: new FormControl(element.format),
                children: new FormGroup({}),
                // deuxième niveau
                checked: new FormControl(element.checked),
                visible: new FormControl(element.visible)
              });
              const zonediffusionctrl: any = this.rowChild.controls.zonediffusion;
              zonediffusionctrl.disable();
              const diffuseurctrl: any = this.rowChild.controls.diffuseur;
              diffuseurctrl.disable();
              const formatctrl: any = this.rowChild.controls.format;
              formatctrl.disable();

              ((this.dataRows.controls[principalRowData.id] as FormGroup)?.controls.children as FormGroup)?.addControl(element.id, this.rowChild);
              ((this.dataRows.controls[principalRowData.id] as FormGroup)?.controls.children as FormGroup)?.setControl(element.id, this.rowChild);
              this.dataRows.addControl(element.id, this.rowChild);
              this.dataRows.setControl(element.id, this.rowChild);
              this.usersData[this.usersData.indexOf(principalRowData)] = {
                ...principalRowData,
                addresses: new MatTableDataSource(principalRowData.children),
              };
            });
          }
        });

        this.form.setControl(Constants.TABLE_DATA_CTRL_NAME, this.dataRows);

        // table princip
        this.tableDataSrc = new MatTableDataSource(this.usersData);
        for (let i = 0; i < this.tableDataSrc.data.length; i++) {
          if (this.tableDataSrc.data[i].children?.length > 0) {
            for (let j = 0; j < this.tableDataSrc.data[i].children.length; j++) {
              if (this.tableDataSrc.data[i].children[j].checked == true) {
                this.tableDataSrc.data[i].expanded = true;

                if (this.selectionMap.get(this.tableDataSrc.data[i].id) == undefined) {
                  this.selectionMap.set(
                    this.tableDataSrc.data[i].id,
                    new SelectionModel<any>(true, [])
                  );
                }
                this.selectionMap.get(this.tableDataSrc.data[i].id).select(this.tableDataSrc.data[i].children[j]);
                if (this.tableDataSrc.data.indexOf(this.tableDataSrc.data[i].children[j]) == -1) {
                  this.tableDataSrc.data[i]?.children.forEach(x => {
                    x.childRow = true;
                    this.tableDataSrc.data.splice(i + 1, 0, x);
                  });
                }
              }
              if (!this.tableDataSrc.data[i].children[j].visible) {
                this.tableDataSrc.data[i].visible = false;
                if (this.visibleMap.get(this.tableDataSrc.data[i].id) == undefined) {
                  this.visibleMap.set(
                    this.tableDataSrc.data[i].id,
                    new SelectionModel<any>(true, [])
                  );
                }
                this.visibleMap.get(this.tableDataSrc.data[i].id).select(this.tableDataSrc.data[i].children[j]);
              }
            }
            ((this.form.controls.tableDataCtrlName as FormGroup).controls[this.tableDataSrc.data[i].id] as FormGroup).controls.checked.setValue((this.selectionMap.get(this.tableDataSrc.data[i].id)?.hasValue() && this.isAllChildSelected(this.tableDataSrc.data[i])));
            this.tableDataSrc.data[i].checked = this.selectionMap.get(this.tableDataSrc.data[i].id)?.hasValue() && this.isAllChildSelected(this.tableDataSrc.data[i]);
            ((this.form.controls.tableDataCtrlName as FormGroup).controls[this.tableDataSrc.data[i].id] as FormGroup).controls.visible.setValue((this.visibleMap.get(this.tableDataSrc.data[i].id)?.hasValue() && this.isAllChildVisible(this.tableDataSrc.data[i])));
            this.tableDataSrc.data[i].visible = this.visibleMap.get(this.tableDataSrc.data[i].id)?.hasValue() && this.isAllChildVisible(this.tableDataSrc.data[i]);
          }
        }
        // column pour l'expend child
        if (this.tableContent.expandedColumn.length > 0) {
          this.expandedColumn = this.tableContent.expandedColumn;
        }

        // Trad auto
        forkJoin({
          itemsPerPageLabel: this.translate.get(
            this.tableauMessage.itemsPerPage
          ),
          nextPageLabel: this.translate.get(this.tableauMessage.nextPage),
          previousPageLabel: this.translate.get(
            this.tableauMessage.previousPage
          ),
          firstPageLabel: this.translate.get(this.tableauMessage.firstPage),
          lastPageLabel: this.translate.get(this.tableauMessage.lastPage),
        }).subscribe((values) => {
          this.paginator._intl.itemsPerPageLabel = values.itemsPerPageLabel;
          this.paginator._intl.nextPageLabel = values.nextPageLabel;
          this.paginator._intl.previousPageLabel = values.previousPageLabel;
          this.paginator._intl.firstPageLabel = values.firstPageLabel;
          this.paginator._intl.lastPageLabel = values.lastPageLabel;
          this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
            return ""
          };

          this.tableDataSrc.sort = this.sort;
          this.tableDataSrc.filterPredicate = (data: any, filter: string) => {
            return data[this.tableContent.uniqueKey].includes(filter);
          };
          this.tableDataSrc.paginator = this.paginator;
        });

        this.compatibilite(false);
        this.canNavigateInStepperService.tryToGetDiffIdByFlux(this.form);
      }
    });
  }

  public onSearchInput(ev) {
    const searchTarget = ev.target.value;
    this.tableDataSrc.filter = searchTarget;
  }

  public getEvent(event, element, id) {

    if ((id === 'INPUT_1' || id === 'INPUT_7') && !element.formulairecode) {
      const value = ((this.dataRows.controls[element.id] as FormGroup).controls.checked as FormGroup).value;
      const keys = Object.keys(((this.dataRows.controls[element.id] as FormGroup).controls.children as FormGroup).controls);
      for (const key of keys) {
        (((this.form.controls.tableDataCtrlName as FormGroup).controls[key] as FormGroup)?.controls.checked as FormGroup)?.setValue(value);
      }
      const index = this.tableDataSrc.data.indexOf(element);
      this.tableDataSrc.data[index].children.forEach(children => {
        children.checked = value;
        const i = this.tableDataSrc.data.indexOf(children);
        this.tableDataSrc.data[i].checked = value;
      });
      if (this.tableDataSrc.data[index].children.length > 0) {
        if (this.isAllChildSelected(element)) {
          this.selectionMap.get(element.id).clear();
        } else {
          this.tableDataSrc.data[index].children.forEach(row =>
            this.selectionMap.get(element.id)?.select(row)
          );
        }
        if (this.isAllChildVisible(element)) {
          this.visibleMap.get(element.id).clear();
        } else {
          this.tableDataSrc.data[index].children.forEach(row => {
            const visibleMapElement = this.visibleMap.get(element.id);
            if (visibleMapElement !== undefined) {
              visibleMapElement.select?.(row);
            }
          });

        }
        ((this.form.controls.tableDataCtrlName as FormGroup).controls[element.id] as FormGroup).controls.checked.setValue(this.selectionMap.get(element.id)?.hasValue() && this.isAllChildSelected(element));
        this.tableDataSrc.data[index].checked = this.selectionMap.get(element.id)?.hasValue() && this.isAllChildSelected(element);
        ((this.form.controls.tableDataCtrlName as FormGroup).controls[element.id] as FormGroup).controls.visible.setValue(this.visibleMap.get(element.id)?.hasValue() && this.isAllChildVisible(element));
        this.tableDataSrc.data[index].visible = this.visibleMap.get(element.id)?.hasValue() && this.isAllChildVisible(element);
      }
    } else {

      this.selectionMap.get(element.idParent)?.toggle(element);
      const value = (((this.form.controls.tableDataCtrlName as FormGroup).controls[element.id] as FormGroup).controls.checked as FormGroup).value;
      const index = this.tableDataSrc.data.indexOf(element);
      this.tableDataSrc.data[index].checked = value;

      let parent;
      let indexParent = -1;
      for (let i = 0; i < this.tableDataSrc.data.length; i++) {
          if (this.tableDataSrc.data[i].id === element.idParent) {
              parent = this.tableDataSrc.data[i];
              indexParent = i;
              break;
          }
      }

      (((this.form.controls.tableDataCtrlName as FormGroup).controls[element.idParent] as FormGroup).controls.checked)
          .setValue(this.selectionMap.get(element.idParent)?.hasValue() && this.isAllChildSelected(parent));
      this.tableDataSrc.data[indexParent].checked = this.selectionMap.get(element.idParent)?.hasValue() && this.isAllChildSelected(parent);
  }


    if (event.type === 'Information') {
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = element.intitule;
      modalRef.componentInstance.contentTitle = this.tableauMessage.contentTitle;
      modalRef.componentInstance.content = element.description;
      modalRef.componentInstance.footerTitle = this.tableauMessage.footerTitle;
      modalRef.componentInstance.url = element.url;
    }
    this.formOutput.emit(this.form);
    this.actionEvent.emit({ action: event, data: element });

  }

  public handlePage(e: any) {
    this.avisNbPerPage = 0;
    if ((((this.paginator.pageIndex + 1) * this.paginator.pageSize) - (this.paginator.length)) > 0) {
      this.avisNbPerPage = (((this.paginator.pageIndex + 1) * this.paginator.pageSize) - (this.paginator.length));
    }
  }

  public isAllChildSelected(element: any): boolean {
    if (!this.usersData.some(d => d.id === element.id)) {
      return false;
    }
    const index = this.tableDataSrc.data.indexOf(element);
    const numSelected = this.selectionMap.get(element.id)?.selected?.length || 0;
    const numRows = this.tableDataSrc.data[index]?.children?.length || 0;
    const result = numSelected === numRows;
    return result;
  }


  isAllChildVisible(element) {
    const index = this.tableDataSrc.data.indexOf(element);
    const numSelected = this.visibleMap.get(element.id) !== undefined ? this.visibleMap.get(element.id).selected.length : 0;
    const numRows = this.tableDataSrc.data[index].children.length;
    return numSelected == numRows;
  }

  isAllChildAutoSelectedDiffuseur(element, listDiff) {
    var testPassed = false;
    this.usersData.forEach(data => {
      if ((data.id) === (element)) {
        var numChild = 0;
        var numSelected = 0;
        if (data.children.length > 0) {
          data.children.forEach(child => {
            numChild++;
            if (listDiff.includes(Number(child.id)))
              numSelected++;
          });
        }
        if ((numChild == numSelected) && numChild > 0 && numSelected > 0)
          testPassed = true;
      }
    });
    return testPassed;
  }

  public compatibilite(aviRefNotNull: boolean) {
    if (this.form.controls.tableDataCtrlName !== undefined) {
      Object.keys((this.form.controls.tableDataCtrlName as FormGroup).controls).forEach(key => {
        const diffFormGrp: any = this.form.get(Constants.TABLE_DATA_CTRL_NAME);
        const diffsCtrl: any = diffFormGrp.controls;
        const childrens = diffsCtrl[key].controls.children.controls;
        Object.keys(childrens).forEach(key2 => {
          if (this.isDisabled(childrens[key2].controls.zonediffusion.value) || !childrens[key2].controls.visible || (!this.diffIdAvisRef.includes(Number(key2)) && this.diffIdAvisRef.length > 0)) {
            childrens[key2].controls.checkbox.disable();
            childrens[key2].controls.checked.disable();
            childrens[key2].controls.checked.setValue(false);
          } else {
            childrens[key2].controls.checkbox.enable();
            childrens[key2].controls.checked.enable();
            if (aviRefNotNull)
              childrens[key2].controls.checked.setValue(true);
          }
        });
        if (this.isDisabled(diffsCtrl[key].controls.zonediffusion.value) || !diffsCtrl[key].controls.visible || (!this.diffIdAvisRef.includes(Number(key)) && this.diffIdAvisRef.length > 0)) {
          diffsCtrl[key].controls.checkbox.disable();
          diffsCtrl[key].controls.checked.disable();
          diffsCtrl[key].controls.checked.setValue(false);
        } else {
          diffsCtrl[key].controls.checkbox.enable();
          diffsCtrl[key].controls.checked.enable();
          if (aviRefNotNull)
            diffsCtrl[key].controls.checked.setValue(true);
        }
        if (this.isAllChildAutoSelectedDiffuseur(key, this.diffIdAvisRef)) {
          diffsCtrl[key].controls.checkbox.enable();
          diffsCtrl[key].controls.checked.enable();
          diffsCtrl[key].controls.checked.setValue(true);
        }
      });
      this.forceBoampSiImpose();
    }
  }

  isDisabled(zonediffusion) {
    switch (this.canNavigateInStepperService.currentNormeFormulaire) {
      case 'EUROPEEN': {
        return false;
      }
      case 'NATIONAL': {
          if(zonediffusion === 'EUROPE'){
            return true;
          } else {
            return false;
          }
      }
      case 'LIBRE': {
        if (zonediffusion === 'NATIONAL' || zonediffusion === 'EUROPE') {
          return true;
        } else {
          return false;
        }
      }
      case 'ADAPTE': {
        return false;
      }
      default: {
        return false;
      }
    }
  }

  public applyFilter(filterValue: string) {
    this.tableDataSrc.filter = filterValue;
  }

  expandRow( row: any) {

    const i = this.tableDataSrc.data.findIndex(item => item.id === row.id);

    if (row.childRow || !row.develop) {
      return;
    }

    if (row.expanded) {
      // remove the flag
      row.expanded = false;

      // remove the child rows
      let childrenDetected = false;
      for (let x = 0; x < this.tableDataSrc.data.length; x++) {
        if (childrenDetected && !this.tableDataSrc.data[x].childRow) {
          break;
        }

        if (x > i && this.tableDataSrc.data[x].childRow) {
          this.tableDataSrc.data.splice(x, 1);
          x--;
          childrenDetected = true;
        }
      }
      this.tableDataSrc._updateChangeSubscription();
      return;
    }

        // set expanded to true so we don't expand this row again
        row.expanded = true;
        // mark as child rows
        this.tableDataSrc.data[i]?.children.forEach(i => i.childRow = true);

        // add rows including header row
        this.tableDataSrc.data[i]?.children.forEach(x => {

          this.tableDataSrc.data.splice(i + 1, 0, x);
        });

        if (this.selectionMap.get(row.id) == undefined) {
          this.selectionMap.set(
            row.id,
            new SelectionModel<any>(true, [])
          );
        }

        if (this.visibleMap.get(row.id) == undefined) {
          this.visibleMap.set(
            row.id,
            new SelectionModel<any>(true, [])
          );
        }
        this.tableDataSrc._updateChangeSubscription();
    }

  createPrefDiffuseur() {
    const ids: Array<Number> = [];
    Object.keys((this.form.controls.tableDataCtrlName as FormGroup).controls).forEach(key => {
      const diffFormGrp: any = this.form.get(Constants.TABLE_DATA_CTRL_NAME);
      const diffsCtrl: any = diffFormGrp.controls;
      const childrens = diffsCtrl[key].controls.children.controls;
      if (Object.keys(childrens).length === 0 && diffsCtrl[key].controls.checked.value) {
        ids.push(Number(key));
      } else {
        Object.keys(childrens).forEach(key2 => {
          if (childrens[key2].controls.checked.value) {
            ids.push(Number(key2));
          }
        });
      }
    });
    const modalRef = this.modalService.open(ModalDiffuseurComponent);
    modalRef.componentInstance.diffuseurIds = ids;
  }



  createPresseSpecial() {
    const modalRef = this.modalService.open(PresseSpecialiseComponent);
    modalRef.componentInstance.mode = 1;
    modalRef.componentInstance.presseOutput
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data: Diffuseur) => {
          this.presseOutput.emit(data);
        }
      });
  }

  updatePresse(id: number) {
    const modalRef = this.modalService.open(PresseSpecialiseComponent);
    modalRef.componentInstance.mode = 2;
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.presseOutput
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data: Diffuseur) => {
          this.presseOutput.emit(data);
        }
      });
  }

  public mapToolTip(element) {
    if (element) { return this.isDisabled(element.zonediffusion) ? (this.canNavigateInStepperService.currentNormeFormulaire === 'ADAPTE' ? 'modal.M012' : 'modal.M011') : ''; }
    return '';
  }
}


export interface Data {
  children?: any[] | MatTableDataSource<any>;
}
